import { Home } from './pages/home'
import { Dropdown } from './pages/dropdown'


class App {
  constructor() {

    if(document.querySelector('.home')) {
      const home = new Home;
    }
    if(document.querySelector(".dropdown_wrap")) {
      const dropdown = new Dropdown();
    }
  }
}

window.onload = function() {
  let app = new App();
};
